import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-50" }, "Client Name: ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-50" }, "Description: ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-50" }, "Project Name: ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-50" }, "Respondent Status: ", -1)
const _hoisted_5 = { class: "text-info" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "opacity-50" }, "Services: ", -1)




const __default__ = {
  name: "ProjectInformations",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  clientName: {
    type: String,
    default: "",
  },
  projectName: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  currentRespondentsCount: {
    type: Number,
    default: 0,
  },
  maxAllowedRespondents: {
    type: Number,
    default: 0,
  },
  services: {
    type: Array,
    default: Array,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", null, [
      _hoisted_1,
      _createTextVNode(" " + _toDisplayString(__props.clientName), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(__props.description), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(__props.projectName), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(__props.currentRespondentsCount), 1),
      _createTextVNode(" / " + _toDisplayString(__props.maxAllowedRespondents), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_6,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.services, (service, i) => {
        return (_openBlock(), _createElementBlock("span", { key: i }, _toDisplayString(service + (i !== __props.services.length - 1 ? ", " : "")), 1))
      }), 128))
    ])
  ]))
}
}

})